import React, { useState, useRef } from 'react';
import {
  Editor,
  EditorState,
  RichUtils,
  convertToRaw,
  convertFromRaw,
  
} from 'draft-js';
import Box from '@mui/material/Box';
import { stateToHTML } from 'draft-js-export-html';
import "draft-js/dist/Draft.css"
import "./rte.css";
import { CustomBoxScroll } from './styles';
const StyleButton = ({onToggle,active,label,style})=> {
    const _onToggle = (e) => {
        e.preventDefault();
        onToggle(style);
    }
    
  
   
    let className = "RichEditor-styleButton";
    if (active) {
    className += " RichEditor-activeButton";
    }

    return (
    <span className={className} onMouseDown={_onToggle}>
        { label}
    </span>
    );
    
  }
  
  const BLOCK_TYPES = [
    { label: "H1", style: "header-one" },
    { label: "H2", style: "header-two" },
    { label: "H3", style: "header-three" },
   
    { label: "Blockquote", style: "blockquote" },
    { label: "UL", style: "unordered-list-item" },
    { label: "OL", style: "ordered-list-item" }
     
  ];
  
  const BlockStyleControls = (props) => {
    const { editorState } = props;
    const selection = editorState.getSelection();
    const blockType = editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();
  
    return (
      <div className="RichEditor-controls">
        {BLOCK_TYPES.map((type) => (
          <StyleButton
            key={type.label}
            active={type.style === blockType}
            label={type.label}
            onToggle={props.onToggle}
            style={type.style}
          />
        ))}
      </div>
    );
  };
  
  var INLINE_STYLES = [
    { label: "Bold", style: "BOLD" },
    { label: "Italic", style: "ITALIC" },
    { label: "Underline", style: "UNDERLINE" } ,
    {
        label: 'Monospace',
        style: 'CODE'
    }
    
  ];
  
  const InlineStyleControls = (props) => {
    var currentStyle = props.editorState.getCurrentInlineStyle();
    return (
      <div className="RichEditor-controls">
        {INLINE_STYLES.map((type) => (
          <StyleButton
            key={type.label}
            active={currentStyle.has(type.style)}
            label={type.label}
            onToggle={props.onToggle}
            style={type.style}
          />
        ))}
      </div>
    );
  };

const RichEditor = ({editorState,setEditorState}) => {
 
  const editorRef = useRef(null);

  const focus = () => editorRef.current.focus();

  const onChange = (newEditorState) => setEditorState(newEditorState);

  const handleKeyCommand = (command) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      onChange(newState);
      return 'handled';
    }
    return 'not-handled';
  };

  const onTab = (e) => {
    const maxDepth = 4;
    onChange(RichUtils.onTab(e, editorState, maxDepth));
  };

  const toggleBlockType = (blockType) => {
    onChange(RichUtils.toggleBlockType(editorState, blockType));
  };

  const toggleInlineStyle = (inlineStyle) => {
    onChange(RichUtils.toggleInlineStyle(editorState, inlineStyle));
  };

  const className = "RichEditor-editor" +
    (!editorState.getCurrentContent().hasText() &&
      editorState.getCurrentContent().getBlockMap().first().getType() !== "unstyled"
      ? " RichEditor-hidePlaceholder"
      : "");

  return (
    <div className="RichEditor-root">
      <BlockStyleControls
        editorState={editorState}
        onToggle={toggleBlockType}
      />
      <InlineStyleControls
        editorState={editorState}
        onToggle={toggleInlineStyle}
      />
      <div className={className} onClick={focus}>
      <Box sx={{overflow:"auto", overflowX:"hidden",  ...CustomBoxScroll,width:1,height:300    }}>
        <Editor
          blockStyleFn={getBlockStyle}
          customStyleMap={styleMap}
          editorState={editorState}
          handleKeyCommand={handleKeyCommand}
          onChange={onChange}
          onTab={onTab}
          ref={editorRef}
          spellCheck={true}
        />
        </Box>
      </div>
    </div>
  );
};

const styleMap = {
  CODE: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

function getBlockStyle(block) {
  switch (block.getType()) {
    case "blockquote":
      return "RichEditor-blockquote";
    default:
      return null;
  }
}
const useEditor = (initState) => {
    const initEditorState = initState == null ? EditorState.createEmpty() : 
        EditorState.createWithContent(convertFromRaw(JSON.parse(initState)))
    const [editorState, setEditorState] = useState(initEditorState);
    const Editor = ()=>{
        return <RichEditor editorState={editorState} setEditorState={setEditorState} />
    }
    const getHtml = ()=>{
        const isEmpty = editorState.getCurrentContent().getPlainText().trim() === ''
        if(isEmpty) return null;
        
        const contentState = editorState.getCurrentContent();
        console.log(JSON.stringify(convertToRaw(contentState)))
         
        return stateToHTML(contentState);
    }
    return [Editor,getHtml]
}
export default useEditor;